import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { ILookupField } from '@/ui-kit/table-filters/filters.type';
import { ICardTransactionFilterFormFields } from '@/store/types/card-transactions.type';

export function mapCardTransactionMid(value: string) {
  return {
    merchantId: value,
  };
}

export function useCardTransactionMidField(
  methods: UseFormReturn<ICardTransactionFilterFormFields>,
  onChange,
): ILookupField {
  const handleMidChange = useCallback(
    (value: ICardTransactionFilterFormFields['mid']) => {
      methods.setValue('mid', value);
      onChange();
    },
    [onChange, methods],
  );

  const mccValue = methods.watch('mid');

  return {
    value: mccValue,
    handleChange: handleMidChange,
  };
}
